<template>
  <div class="home-content-with-image">
    <div class="content-block">
      <h2>{{ $t('helloMsg') }}</h2>
      <p>{{ $t('businessIntro') }}</p>
      <p>{{ $t('businessIntroTagline') }}</p>
    </div>
    <div class="content-image">
      <ContentImage />
    </div>
  </div>
</template>

<script>
  import ContentImage from '@/components/ContentImage'
  export default {
    name: 'HomeContentWithImage',
    components: {
      ContentImage
    }
  }
</script>

<style scoped lang="scss">
  .home-content-with-image {
    @apply flex items-center p-4 pt-6;
    position: relative;
    z-index: 2;
    
    .content-block {
      @apply flex-1 pr-4;

      h2 {
        @apply font-medium leading-loose text-3xl;
        text-shadow: 1px 1px 1px #fff;
      }

      p {
        @apply pb-3 pr-8;
        text-shadow: 1px 1px 1px #fff;
      }
    }
    .content-image {
      @apply flex-1 ml-2 flex justify-center;
      background-blend-mode: multiply;
      svg {
        @apply h-auto w-full;
      }
    }
    @screen lg {
      .content-block {
        h2 {
          @apply text-2xl;
        }
      }
    }
    @screen md {
      .content-block {
        h2 {
          @apply text-xl;
        }
        p {
          @apply text-sm;
        }
      }
    }
    @screen sm {
      @apply flex-col text-center;
      
      .content-block {
        @apply w-5/6 pr-0 pt-4;
        h2 {
          @apply text-2xl;
        }
        p {
          @apply text-sm pb-6 pr-0;
        }
      }
      .content-image {
        @apply w-full pt-0;
        
      }
    }
  }
</style>